import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Star } from "lucide-react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const testimonials = [
  {
    name: "A.B.",
    text: "Grazie al percorso con te abbiamo lavorato su quali fossero i miei pensieri limitanti, riconoscere e far rispettare i propri confini personali, scoperto i miei valori guida e quale versione di me voler essere portandomi a una grande crescita di consapevolezza ma soprattutto mi ha fatto evolvere dalla consapevolezza all'azione facendo luce sulla mia missione di vita e facendo sbocciare di pi\u00f9 la mia essenza. Mi hai insegnato a notare e festeggiare i successi, i baby step quotidiani e apprezzarmi di pi\u00f9 facendo crescere la mia sicurezza e autostima.",
    role: "",
  },
  {
    name: "M.A.",
    text: "La tua intelligente ironia per me \u00e8 una grande fonte di benessere, mi fa respirare e alleggerire tutto, sei preparatissima, lucida, mirata, sai disinnescare le mie resistenze e tutto questo grazie al tuo sorriso e una profondissima capacit\u00e0 di saper sentire e leggere nel profondo andando oltre le apparenze. Sono rimasta colpita dalla tua velocit\u00e0 di intuizione e i risultati di Benessere concreti e duraturi sia emotivi che pratici nella vita quotidiana che ho ottenuto.",
    role: "",
  },
  {
    name: "A.T.",
    text: "Dopo anni di psicoterapia e avendo iniziato percorsi di meditazione sentivo la necessit\u00e0 di lavorare in maniera mirata e pratica su alcune tematiche di crescita personale coinvolgendo nelle sessioni pi\u00f9 piani: la mente, anima e corpo. Mi sono rivolta a te con fiducia, grazie al tuo percorso ho ottenuto la forza, la Pace e Serenit\u00e0 che desideravo per rinascere. Oggi mi sento pi\u00f9 centrata e luminosa sia come persona che come professionista.",
    role: "",
  },
  {
    name: "T.A.",
    text: "Alessia ma lo sai che dopo la nostra sessione, due clienti mi hanno chiesto di iniziare un lavoro con me? Il lavoro con te ha creato proprio un forte movimento! Grazie davvero per l'incontro di oggi. Mi sono sentita vista subito nelle mie difficolt\u00e0 e in ci\u00f2 su cui ho bisogno di portare l'attenzione! Ho adorato la visualizzazione in cui mi hai guidata, mi ha aiutata a far parlare la parte pi\u00f9 profonda di me. L'immagine del ponte e l'incontro con la mia visione dall'altra parte mi \u00e8 rimasta dentro. Mi sono sentita accompagnata, sostenuta e al sicuro. Non vedo l'ora di proseguire questo percorso con te.",
    role: "",
  },
  {
    name: "S.A.",
    text: "Cara Alessia, volevo prendermi un momento per dirti grazie, davvero. Guardare pi\u00f9 da vicino la mia parte organizzativa e osservare come utilizzo le mie energie durante la giornata sta diventando qualcosa di molto prezioso per me. Il tuo accompagnamento mi sta aiutando non solo a capire quali cose importanti introdurre nella mia vita, ma anche ad avere punti di riferimento concreti, abitudini e appoggi a cui tornare. \u00c8 la prima volta che, all'interno di un percorso di crescita personale, mi dedico cos\u00ec tanto alla dimensione dell'azione e dell'organizzazione. Sono davvero contenta e grata di essere accompagnata da te in questo momento.",
    role: "",
  },
];

const TestimonialsSection = () => {
  return (
    <section
      id="testimonianze"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#ECEAE6]"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <AnimatedBlock>
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-[0.2em] text-[#AC8E60] font-body font-semibold mb-4">
              Testimonianze
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#442F23] mb-6">
              Voci dalla Community
            </h2>
            <div className="section-divider" />
          </div>
        </AnimatedBlock>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <AnimatedBlock key={t.name} delay={i * 0.1}>
              <div
                className="bg-[#FBF8E9] border border-[#AC8E60]/10 rounded-[1.5rem] p-8 card-hover h-full flex flex-col"
                data-testid={`testimonial-card-${i}`}
              >
                {/* Stars */}
                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, j) => (
                    <Star
                      key={j}
                      size={14}
                      className="fill-[#E1C340] text-[#E1C340]"
                    />
                  ))}
                </div>

                {/* Quote */}
                <p className="font-heading text-base italic text-[#442F23]/80 leading-relaxed flex-1 mb-8">
                  &ldquo;{t.text}&rdquo;
                </p>

                {/* Author */}
                <div>
                  <p className="font-body text-sm font-semibold text-[#442F23]">
                    {t.name}
                  </p>
                  {t.role && (
                    <p className="font-body text-xs text-[#AC8E60]">{t.role}</p>
                  )}
                </div>
              </div>
            </AnimatedBlock>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
